// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__t732+","content":"Layout_content__fwmv4","contentExpanded":"Layout_contentExpanded__qqras","contentCollapsed":"Layout_contentCollapsed__Pya+f"};